import React from "react";
import Loading from "../../../../../ui-components/loading/loading";
import { ReactComponent as Pickupcreated } from "../../../../../images/time_blue_pickup.svg";
import { ReactComponent as Pickupcompleted } from "../../../../../images/time_pur_check.svg";
import { ReactComponent as Pickupmissed } from "../../../../../images/pickup_missed_cross.svg";
import { ReactComponent as Pickuprescheduled } from "../../../../../images/status-refresh-pickup.svg";
import { ReactComponent as Pickupcancelled } from "../../../../../images/cancel-svgrepo-pickup.svg";

export enum PicklistsSummaryTileTypes {
    created = "created",
    completed = "completed",
    missed = "missed",
    rescheduled = "rescheduled",
    cancelled = "cancelled"
}
interface PicklistsSummaryTileProps {
    type: PicklistsSummaryTileTypes;
    isLoading: boolean;
    title: string;
    value: string | number;
}

const getTileIcon = (type: PicklistsSummaryTileTypes) => {
    if (type === "created") return <Pickupcreated />;
    else if (type === "completed") return <Pickupcompleted />;
    else if (type === "missed") return <Pickupmissed />;
    else if (type === "rescheduled") return <Pickuprescheduled />;
    else if (type === "cancelled") return <Pickupcancelled />;
    else return "";
}

export const PicklistsSummaryTile: React.FC<PicklistsSummaryTileProps> = (props) => {

    return (<div className="xgs-pickupsummary-summary__tile">
        <div className={`icon-container --type-${props.type}`}>
            {getTileIcon(props.type)}
        </div>
        <div className="content">
            {props.isLoading ?
                <Loading isLoading={true} /> :
                <div className="value">{props.value}</div>
            }
            <div className="title">{props.title}</div>

        </div>
    </div>
    )
};